<template>
    <article class="post">
        <post-header v-bind:post="post"></post-header>
        <div class="body-text">
            <p>Welcome to the new and redisigned <router-link to="/" class="evergreen">LinusMarco.com</router-link>!
            <p>To start, this blog will be a conglomeration of posts on three subjects that I am passionate about: Data Visualization, Web Development, and Baseball.</p>
            <p>In an upcoming post, I will give an overview of how I built this site, which uses a few interesting tools and patterns including:</p>
                <ul>
                    <li>Vue.js with lazy-loading components</li>
                    <li>Serverless architecture on AWS (CloudFront + S3 + Lambda + DynamoDB)</li>
                </ul>
            <p>Finally, if you used to use any of the applications that were hosted on the old version of this site, those will be down for a while. I'm hoping to put those back up (same routes, probably) once I have a chance to work them into the new site design.</p>
            <p>Stay tuned!</p>
        </div>
    </article>
</template>

<script>
import PostHeader from '../../post-sections/post-header.vue';

export default {
    name: 'welcome',
    props: ['post'],
    components: {
        'post-header': PostHeader
    },
    data() {
        return {};
    }
};
</script>
